import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IUserPointsRedemptionRequest } from '@/shared/model/user-points-redemption-request.model';

const baseApiUrl = 'api/user-points-redemption-requests';
const baseSearchApiUrl = 'api/user-points-redemption-requests?';

export default class UserPointsRedemptionRequestService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IUserPointsRedemptionRequest> {
    return new Promise<IUserPointsRedemptionRequest>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IUserPointsRedemptionRequest): Promise<IUserPointsRedemptionRequest> {
    return new Promise<IUserPointsRedemptionRequest>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IUserPointsRedemptionRequest): Promise<IUserPointsRedemptionRequest> {
    return new Promise<IUserPointsRedemptionRequest>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
